import BaseApi from "../../BaseApi";

export class API extends BaseApi {

  constructor() {
    super();
    this.site = scriptsData.siteUrl;
  }

  async loadTopics(topic) {
    const apiUrl = `${this.site}wp-json/wp/v2/get-topics`;
    return this.get(apiUrl);
  }

  async loadContent(term) {
    const topicParam = term ? `?topic=${term}` : '';
    const apiUrl = `${this.site}wp-json/wp/v2/get-faqs${topicParam}`;
    return this.get(apiUrl);
  }

  async searchContent(query) {
    const apiUrl = `${this.site}wp-json/wp/v2/search-faqs?search=${query}`;
    return this.get(apiUrl);
  }

  getFragmentFromUrl() {
    const fragment = window.location.hash.substring(1);
    return fragment ? fragment : false;
  }
}
